<template>
	<v-slide-x-reverse-transition>
		<v-sheet class="sliderDrawer"
				 tile :elevation="visible ? 9 : 0"
				 :style="style">
			<portal-target name="sliderDrawer"
						   multiple
						   :transition="transition"
						   @change="onPortalTargetChange" />
		</v-sheet>
	</v-slide-x-reverse-transition>
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import SliderTransition from "./SliderTransition.vue";
import { CreateElement } from 'vue';
import SliderContent from "./SliderContent.vue";
import SliderService from "../services/sliderService";

@Component({
	inheritAttrs: false,
	components: {
		SliderTransition
	}
})
export default class SliderDrawer extends Vue {
	visible: boolean = false;
	current: SliderContent = null;
	style: any = null;
	children: SliderContent[] = [];

	get currentChild() {
		return this.children.slice(-1).pop();
	}

	get size() {
		return this.currentChild ? this.currentChild.size : 0;
	}

	@Watch("size")
	@Watch("visible")
	setStyle() {
		const width = this.visible ? SliderService.getWidth(this.size) : 0;
		this.style = {
			width
		};
	}

	get transition() {
		return {
			functional: true,
			render: (h: CreateElement, context) => {
				return h(SliderTransition, {
					on: {
						beforeEnter: () => this.onBeforeEnter(context.children),
						beforeLeave: () => this.onBeforeLeave(context.children),
					}
				}, context.children)
			}
		}
	}

	onBeforeEnter(children) {
		//console.log('onBeforeEnter', children);
		this.children = children.map(x => x.componentInstance);
	}

	onBeforeLeave(children) {
		//console.log('onBeforeLeave', children);
		this.children.pop();
	}

	onPortalTargetChange(visible: boolean) {
		//console.log('onPortalTargetChange', visible);
		this.visible = visible;
	}
}
</script>

<style lang="scss">
.sliderDrawer {
	display: block;
	position: fixed;
	max-width: 100vw;
	bottom: 0;
	right: 0;
	top: 0;
	z-index: 9;
	transition: width 250ms;
	will-change: width;
}

@media print {
	.sliderDrawer {
		display: none !important;
	}
}
</style>